// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Webinars20 from './Webinars20.tsx';
import Webinars20Filled from './Webinars20Filled.tsx';
import Webinars24 from './Webinars24.tsx';
import Webinars24Filled from './Webinars24Filled.tsx';
import Webinars40 from './Webinars40.tsx';
import Webinars40Filled from './Webinars40Filled.tsx';
import Webinars48 from './Webinars48.tsx';
import Webinars48Filled from './Webinars48Filled.tsx';

type WebinarsProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Webinars20,
    Webinars20Filled,
    Webinars24,
    Webinars24Filled,
    Webinars40,
    Webinars40Filled,
    Webinars48,
    Webinars48Filled,
};

const Webinars: FC<WebinarsProps> = ({ variation, ...props }) => {
    const variationKey = `Webinars${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Webinars" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Webinars;
